var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32.967,
    viewBox: "0 0 34 32.967",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star-solid",
    d: "M47.086,9.64,56.337,11a2.059,2.059,0,0,1,1.146,3.5l-6.709,6.58,1.584,9.438a2.063,2.063,0,0,1-3,2.163l-8.267-4.41-8.26,4.41a2.074,2.074,0,0,1-2.176-.148,2.05,2.05,0,0,1-.824-2.015l1.584-9.438-6.71-6.58A2.07,2.07,0,0,1,24.2,12.4,2.048,2.048,0,0,1,25.854,11L35.1,9.64l4.146-8.52a2.057,2.057,0,0,1,3.7,0Z",
    transform: "translate(-24.095 0.039)",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.2f375b91f69f780eb403b0ac62914979.svg";